import {ECODE_LENGTHS, TCODE_LENGTHS} from '../config/iban.config';

export function isJsonString(str: string) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function isValidIBANNumber(input: string) {
  const iban = String(input)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
  const code: any[] | null = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);
  let digits;
  if (!code) {
    return false;
  }
  const ibanLength: TCODE_LENGTHS = +ECODE_LENGTHS[code[1]];

  if (iban.length !== ibanLength) {
    return false;
  }
  digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function(letter: string) {
    return letter.charCodeAt(0) - 55;
  });
  return mod97(digits);
}

export function mod97(iban: string) {
  let checksum = +iban.slice(0, 2);
  let fragment;
  for (let offset = 2; offset < iban.length; offset += 7) {
    fragment = String(checksum) + iban.substring(offset, offset + 7);
    checksum = parseInt(fragment, 10) % 97;
  }
  return checksum;
}
